<template>
  <organism-idc-edit-and-action-contract
    v-model="contractDetail"
    :contract-start-date="contractDetail.startDate"
    :business-type-option="businessTypeOption"
    :service-option="serviceOption"
    :location-option="locationOption"
    :contact-point-option="contactPointOption"
    :sale-option="saleOption"
    :form-option="formOption"
    :selected-contact-point-id="selectedContactPointId"
    :selected-contact-point-detail="selectedContactPointDetail"
    :selected-sale-contact-id="selectedSaleContactId"
    :selected-sale-contact-detail="selectedSaleContactDetail"
    :generated-account-data="generatedAccountData"
    :attachment-tag-option="attachmentTagOption"
    :func-get-package-name-list="getPackageNameListByServiceIdFromApi"
    :func-get-service-and-package-detail="getServiceAndPackageDetailByIdFromApi"
    :escalation-template-list="escalationTemplateList"
    :escalation="escalation"
    :escalation-detail="escalationDetail"
    :current-escalation-id="currentEscalationId"
    @onChangeEscalationTemplate="onChangeEscalationTemplate"
    @onSelectService="onSelectService"
    @onSelectPackage="onSelectPackage"
    @onSelectContactPoint="onSelectContactPoint"
    @onSelectSaleContact="onSelectSaleContact"
    @onClearSelectedSaleContactId="onClearSelectedSaleContactId"
    @onClearSelectedContactPointId="onClearSelectedContactPointId"
    @onRequestCreateNewContactPoint="onRequestCreateNewContactPoint"
    @onUpdateContactPointProfilePicture="onUpdateContactPointProfilePicture"
    @onRequestCreateNewSaleContact="onRequestCreateNewSaleContact"
    @onUpdateSaleProfilePicture="onUpdateSaleProfilePicture"
    @onRequestForm="onRequestForm"
    @onConfirmDeleteContract="onConfirmDeleteContract"
    @onConfirmApproveContract="onConfirmApproveContract"
    @onConfirmResumeContract="onConfirmResumeContract"
    @onConfirmRenewContract="onConfirmRenewContract"
    @onConfirmSuspendContract="onConfirmSuspendContract"
    @onConfirmExpireContract="onConfirmExpireContract"
    @onGenerateCustomerAccount="onGenerateCustomerAccount"
    @onRequestAddNewNote="onRequestAddNewNote"
    @onRequestDeleteNote="onRequestDeleteNote"
    @onSaveChangeContractDetail="onSaveChangeContractDetail"
    @onRequestAddAttachment="onRequestAddAttachment"
    @onRequestEditAttachment="onRequestEditAttachment"
    @onRequestDeleteAttachment="onRequestDeleteAttachment"
    @onSelectSite="onSelectSite"
  />
</template>

<script>
import OrganismIdcEditAndActionContract from "@/components/organisms/portal/internal/idc/OrganismIdcEditAndActionContract.vue"
import mixins from "@/mixins"
import mixinsDatetime from "@/mixins/mixinsDatetime"
import {
  getServicesName,
  getContactPointAndSaleNameList,
  getPackageNameListByServiceId,
  getServiceAndPackageDetailById,
  getLocationList,
  getBusinessTypeList,
  getContactPointOrSaleDetailById,
  getContactPointForm,
  getFormList,
  changeContractStatus,
  generateUserCustomer,
  createNewContractNote,
  deleteContractNote,
  createNewContactPointOrSale,
  updateProfilePicture,
  getSharedTags,
  uploadContractAttachment,
  editContractAttachment,
  deleteContractAttachment,
  getContractByIdcId,
  updateContractById,
} from "@/api/api-module1"

import mixinsSiteHelper from "@/mixins/mixinsSiteHelper"
import {
  getTicketEscalationActiveList,
  getTicketEscalationById,
} from "@/api/module-1/escalation"

export default {
  name: "IdcEditAndActionContract",
  components: {
    OrganismIdcEditAndActionContract,
  },
  mixins: [mixins, mixinsDatetime, mixinsSiteHelper],
  data() {
    return {
      businessTypeOption: [],
      serviceOption: [],
      saleOption: [],
      contactPointOption: [],
      locationOption: [],
      formOption: [],
      allContactPointList: [],
      selectedContactPointId: null,
      selectedContactPointDetail: {},
      selectedSaleContactId: null,
      selectedSaleContactDetail: {},
      generatedAccountData: {
        username: "",
        password: "",
      },
      serviceDetailInfo: [],
      contractDetail: {
        contractId: "",
        additionalIds: [],
        contractStatus: "",
        customer: {
          customerId: "",
          customerName: "",
          mainAddress: {
            organizationName: "",
            businessType: "",
            phone: "",
            fax: "",
            email: "",
            country: "",
            province: "",
            district: "",
            subDistrict: "",
            address: "",
            postalCode: "",
          },
          billingAddress: {
            organizationName: "",
            businessType: "",
            phone: "",
            fax: "",
            email: "",
            country: "",
            province: "",
            district: "",
            subDistrict: "",
            address: "",
            postalCode: "",
            vatType: "",
          },
          mailingAddress: {
            organizationName: "",
            businessType: "",
            phone: "",
            fax: "",
            email: "",
            country: "",
            province: "",
            district: "",
            subDistrict: "",
            address: "",
            postalCode: "",
          },
        },
        serviceDetail: {
          service: "",
          package: null,
          quantity: null,
          contractPeriod: null,
          location: null,
          rack: null,
          domain: null,
          startDate: "",
          serviceNote: "",
          otherTechnicalDetail: "",
          packageOptions: [],
        },
        contactPointList: [],
        saleContactList: [],
        contractNotes: [],
      },
      attachmentTagOption: [],
      escalationTemplateList: [],
      escalation: null,
      currentEscalationId: null,
      escalationDetail: {
        name: "",
        description: "",
        levels: [],
      },
    }
  },
  computed: {
    originContractId() {
      return this.$route?.params?.id
    },
    contractId() {
      return this.$route?.params?.id.replace(/\D/g, "")
    },
  },
  watch: {
    contractId: {
      deep: true,
      immediate: true,
      handler() {
        const isIdExist = this.originContractId && this.contractId
        const isIdWrongFormat = this.originContractId !== this.contractId
        const idIdLengthExceed = this.originContractId.length !== 8
        if ((isIdExist && isIdWrongFormat) || idIdLengthExceed) {
          this.toastError("NTDC ID does not exist")
          this.navigateTo("/internal/web-portal/idc")
        } else {
          this.getBusinessTypeListFromApi()
          this.getContractDetailByIdFromApi()
        }
      },
    },
  },

  methods: {
    navigateTo(path) {
      this.$router.push(path)
    },

    async getTicketEscalationActiveList() {
      this.showLoading(true)
      await getTicketEscalationActiveList()
        .then((response) => {
          this.escalationTemplateList = response.data
        })
        .finally(() => this.showLoading(false))
    },

    async getContractDetailByIdFromApi() {
      this.showLoading(true)
      await this.fetchOptionDataFromApi()
      await getContractByIdcId(this.contractId)
        .then(async (response) => {
          this.contractDetail = response
          this.contractDetail.additionalIds = response?.additionalIds || []

          if (response?.escalationId) {
            this.currentEscalationId = response?.escalationId
            this.escalation = this.escalationTemplateList.find(
              (escalation) => escalation.escalationId === response?.escalationId
            )

            await this.getEscalationDetail(response.escalationId)
          }
        })
        .catch(() => {
          this.toastError("Contract Not Found")
          this.navigateTo("/internal/web-portal/idc")
        })
        .finally(() => this.showLoading(false))
    },

    async fetchOptionDataFromApi() {
      if (
        !this.businessTypeOption?.length ||
        !this.serviceOption?.length ||
        !this.saleOption?.length ||
        !this.contactPointOption?.length ||
        !this.locationOption?.length
      ) {
        await this.getAttachmentTagOptionFromApi()
        await this.getBusinessTypeListFromApi()
        await this.getServiceListFromApi()
        await this.getContactPointAndSaleNameListFromApi()
        await this.getFormListFromApi()
      }

      await this.getTicketEscalationActiveList()
    },

    async getAttachmentTagOptionFromApi() {
      const tagFilter = {
        TagTypes: [1],
      }
      const isInternal = true
      await getSharedTags(tagFilter, isInternal).then((response) => {
        this.attachmentTagOption = response.map((item) => item.key)
      })
    },

    async getServiceListFromApi() {
      await getServicesName().then((response) => {
        this.serviceOption = response
      })
    },

    async getBusinessTypeListFromApi() {
      await getBusinessTypeList().then((response) => {
        this.businessTypeOption = response.data
      })
    },

    async getFormListFromApi() {
      await getFormList().then((response) => {
        this.formOption = response.data
      })
    },

    async getContactPointAndSaleNameListFromApi() {
      await getContactPointAndSaleNameList().then((response) => {
        this.saleOption = response.data.filter(
          (data) => data.contactType.toLowerCase() === "sale"
        )
        this.contactPointOption = response.data.filter(
          (data) => data.contactType.toLowerCase() === "customer"
        )
      })
    },

    async getPackageNameListByServiceIdFromApi(serviceId) {
      return await getPackageNameListByServiceId(serviceId)
    },

    async getServiceAndPackageDetailByIdFromApi(serviceId, packageId) {
      return await getServiceAndPackageDetailById(serviceId, packageId)
    },

    async getLocationListFromApi(selectedSite) {
      const params = {
        siteId: selectedSite?.siteId ? selectedSite.siteId : undefined,
      }
      await getLocationList(params).then((response) => {
        this.locationOption = response.data
      })
    },

    async getContactPointDetailByIdFromApi(selectedContactPointId) {
      await getContactPointOrSaleDetailById(selectedContactPointId).then(
        (response) => {
          this.selectedContactPointDetail = response.data
        }
      )
    },

    async getSaleDetailByIdFromApi(selectedSaleId) {
      await getContactPointOrSaleDetailById(selectedSaleId).then((response) => {
        this.selectedSaleContactDetail = response.data
      })
    },

    async sendRequestContactPointFormApi(contractId, formId, requestFormData) {
      this.showLoading(true)
      await getContactPointForm(contractId, formId, requestFormData)
        .then((response) => {
          if (response) {
            this.toastSuccess("Downloaded Successfully")
          } else {
            this.toastError("Download Failed")
          }
        })
        .finally(() => this.showLoading(false))
    },

    async changeContractStatusApi(contractId, status) {
      this.showLoading(true)
      await changeContractStatus(contractId, status)
        .then((response) => {
          if (response) {
            this.toastSuccess("Change Status Successfully")
            this.$router.go()
          } else {
            this.toastError("Change Status Failed")
          }
        })
        .finally(() => this.showLoading(false))
    },

    async generateAccountFromApi(generateAccountData) {
      this.showLoading(true)
      await generateUserCustomer(generateAccountData)
        .then((response) => {
          this.generatedAccountData = response.data
        })
        .finally(() => this.showLoading(false))
    },

    async addNewContractNoteApi(contractId, newNoteData) {
      this.showLoading(true)
      const noteData = { note: newNoteData }
      await createNewContractNote(contractId, noteData)
        .then((response) => {
          if (response) {
            this.toastSuccess("Created New Note Successfully")
            this.getContractDetailByIdFromApi()
          } else {
            this.toastError("Create New Note Failed")
          }
        })
        .finally(() => this.showLoading(false))
    },

    async deleteContractNoteApi(contractId, targetNoteId) {
      this.showLoading(true)
      await deleteContractNote(contractId, targetNoteId)
        .then((response) => {
          if (response) {
            this.toastSuccess("Deleted Note Successfully")
            this.getContractDetailByIdFromApi()
          } else {
            this.toastError("Delete Note Failed")
          }
        })
        .finally(() => this.showLoading(false))
    },

    async createNewContactPointApi(newContactPointData) {
      this.showLoading(true)
      await createNewContactPointOrSale(newContactPointData)
        .then((response) => {
          if (response) {
            this.getContactPointAndSaleNameListFromApi()
            this.selectedContactPointId = response.data
            this.toastSuccess("Create Contact Point/Sale Successfully")
            if (this.currentContactPointProfilePicture) {
              const contactId = response.data
              this.updateContactPointProfilePictureApi(contactId)
            }
          } else {
            this.toastError("Create Contact Point/Sale Failed")
            this.currentContactPointProfilePicture = null
          }
        })
        .finally(() => this.showLoading(false))
    },

    async updateContactPointProfilePictureApi(contactId) {
      this.showLoading(true)
      await updateProfilePicture(
        this.currentContactPointProfilePicture,
        contactId
      )
        .then((response) => {
          if (response) {
            this.toastSuccess("Update Profile Picture Successfully")
          } else {
            this.toastError("Update Profile Picture Failed")
          }
          this.currentContactPointProfilePicture = null
        })
        .finally(() => this.showLoading(false))
    },

    async createNewSaleContactApi(newSaleData) {
      this.showLoading(true)
      await createNewContactPointOrSale(newSaleData)
        .then((response) => {
          if (response) {
            this.getContactPointAndSaleNameListFromApi()
            this.selectedSaleContactId = response.data
            this.toastSuccess("Create Contact Point/Sale Successfully")
            if (this.currentSaleProfilePicture) {
              const contactId = response.data
              this.updateSaleProfilePictureApi(contactId)
            }
          } else {
            this.toastError("Create Contact Point/Sale Failed")
            this.currentSaleProfilePicture = null
          }
        })
        .finally(() => this.showLoading(false))
    },

    async updateSaleProfilePictureApi(contactId) {
      this.showLoading(true)
      await updateProfilePicture(this.currentSaleProfilePicture, contactId)
        .then((response) => {
          if (response) {
            this.toastSuccess("Update Profile Picture Successfully")
          } else {
            this.toastError("Update Profile Picture Failed")
          }
          this.currentSaleProfilePicture = null
        })
        .finally(() => this.showLoading(false))
    },

    async sendRequestUpdateContractByIdApi(contractId, contractDetail) {
      this.showLoading(true)
      await updateContractById(contractId, contractDetail)
        .then((response) => {
          if (response) {
            this.toastSuccess("Update Contract Successfully")
            this.getContractDetailByIdFromApi()
          } else {
            this.toastError("Update Contract Failed")
          }
        })
        .finally(() => this.showLoading(false))
    },

    async onChangeEscalationTemplate(escalationSelected) {
      this.escalation = escalationSelected
      this.escalationDetail = {
        name: "",
        description: "",
        levels: [],
      }

      if (this.escalation?.escalationId) {
        await this.getEscalationDetail(this.escalation?.escalationId)
      }
    },

    async getEscalationDetail(escalationId) {
      this.showLoading(true)
      await getTicketEscalationById(escalationId)
        .then((response) => {
          this.escalationDetail = response
        })
        .finally(() => this.showLoading(false))
    },

    onSelectSite(selectedSite) {
      this.getLocationListFromApi(selectedSite)
    },

    onSelectContactPoint(selectedContactPoint) {
      const contactPointId = selectedContactPoint.contactPointId
      this.getContactPointDetailByIdFromApi(contactPointId)
    },

    onClearSelectedContactPointId() {
      this.selectedContactPointId = null
    },

    onSelectSaleContact(selectedSale) {
      const saleId = selectedSale.contactPointId
      this.getSaleDetailByIdFromApi(saleId)
    },

    onClearSelectedSaleContactId() {
      this.selectedSaleContactId = null
    },

    onSelectService(selectedService) {
      this.getPackageNameListByServiceIdFromApi(selectedService.serviceId)
    },

    onSelectPackage(selectedPackage, selectedService) {
      this.getServiceAndPackageDetailByIdFromApi(
        selectedService.serviceId,
        selectedPackage.packageId
      )
    },

    onRequestCreateNewSaleContact(newSaleContactDetail) {
      const newSaleContactDataToApi =
        this.decorateNewSaleContactDetailDataToApi(newSaleContactDetail)
      this.createNewSaleContactApi(newSaleContactDataToApi)
      this.getContactPointAndSaleNameListFromApi()
    },

    onRequestCreateNewContactPoint(contactPointDetail) {
      const newContactPointDataToApi =
        this.decorateNewContactPointDetailDataToApi(contactPointDetail)
      this.createNewContactPointApi(newContactPointDataToApi)
      this.getContactPointAndSaleNameListFromApi()
    },

    onUpdateContactPointProfilePicture(newProfilePicture) {
      this.currentContactPointProfilePicture = newProfilePicture
    },

    onUpdateSaleProfilePicture(newProfilePicture) {
      this.currentSaleProfilePicture = newProfilePicture
    },

    decorateNewContactPointDetailDataToApi(contactPointDetail) {
      const contactPointDataToApi = {
        contactType: "CUSTOMER",
        firstname: contactPointDetail.firstName,
        lastname: contactPointDetail.lastName,
        idType: contactPointDetail.idType,
        identification: contactPointDetail.idOrPassportNumber,
        emails: this.getEmailList(contactPointDetail),
        phones: this.getPhoneList(contactPointDetail),
        accesses: this.getAccessList(contactPointDetail),
      }
      return contactPointDataToApi
    },

    decorateNewSaleContactDetailDataToApi(newSaleContactDetail) {
      const saleDataToApi = {
        contactType: "SALE",
        firstname: newSaleContactDetail.firstName,
        lastname: newSaleContactDetail.lastName,
        idType: newSaleContactDetail.idType,
        identification: newSaleContactDetail.idOrPassportNumber,
        emails: this.getEmailList(newSaleContactDetail),
        phones: this.getPhoneList(newSaleContactDetail),
        accesses: [],
      }
      return saleDataToApi
    },

    getEmailList(contactDetail) {
      const emailList = [
        contactDetail.email.primary,
        contactDetail.email.secondary,
        contactDetail.email.third,
      ]
      return emailList.filter((email) => email)
    },

    getPhoneList(contactDetail) {
      const phoneList = [
        contactDetail.phone.primary,
        contactDetail.phone.secondary,
        contactDetail.phone.third,
      ]
      return phoneList.filter((phone) => phone)
    },

    getAccessList(contactDetail) {
      return contactDetail.accesses.map((access) => {
        return {
          accessCardNumber: access.accessCardNumber,
          locationId: access.locationId,
        }
      })
    },

    onRequestForm(contractId, formId, requestFormData) {
      this.sendRequestContactPointFormApi(contractId, formId, requestFormData)
    },

    onConfirmDeleteContract(contractId) {
      const status = "DELETED"
      this.changeContractStatusApi(contractId, status)
    },

    onConfirmApproveContract(contractId) {
      const status = "APPROVED"
      this.changeContractStatusApi(contractId, status)
    },

    onConfirmResumeContract(contractId) {
      const status = "APPROVED"
      this.changeContractStatusApi(contractId, status)
    },

    onConfirmRenewContract(contractId) {
      const status = "APPROVED"
      this.changeContractStatusApi(contractId, status)
    },

    onConfirmSuspendContract(contractId) {
      const status = "SUSPENDED"
      this.changeContractStatusApi(contractId, status)
    },

    onConfirmExpireContract(contractId) {
      const status = "EXPIRED"
      this.changeContractStatusApi(contractId, status)
    },

    onGenerateCustomerAccount(generateAccountData) {
      this.generateAccountFromApi(generateAccountData)
    },

    onRequestAddNewNote(contractId, newNoteData) {
      this.addNewContractNoteApi(contractId, newNoteData)
    },

    onRequestDeleteNote(contractId, targetNoteId) {
      this.deleteContractNoteApi(contractId, targetNoteId)
    },

    onSaveChangeContractDetail(contractDetail) {
      const contractId = contractDetail.contractId
      const updatedContractDetail =
        this.decorateUpdatedContractDetailToApi(contractDetail)
      this.sendRequestUpdateContractByIdApi(contractId, updatedContractDetail)
    },

    decorateUpdatedContractDetailToApi(contractDetail) {
      const contactPointsList = contractDetail.contactPoints.map((item) => {
        if (item.hasOwnProperty("contactId")) {
          return {
            contactPointId: item.contactId,
            contactPointEmailId: item.contactEmailId,
            contactPointPhoneId: item.contactPhoneId,
            contactPointAccessCard: item.contactAccessCard,
          }
        } else {
          return item
        }
      })
      const saleContactList = contractDetail.saleContact.map((item) => {
        if (item.hasOwnProperty("contactId")) {
          return {
            contactPointId: item.contactId,
            contactPointEmailId: item.contactEmailId,
            contactPointPhoneId: item.contactPhoneId,
            contactPointAccessCard: item.contactAccessCard,
          }
        } else {
          return item
        }
      })
      return {
        additionalIds: contractDetail.additionalIds,
        customerId: contractDetail.customer.customerId,
        packages: contractDetail.packages.map((item) => {
          return {
            contractPackageId: item?.contractPackageId,
            serviceId: item.serviceId,
            packageId: item.packageId,
            packageQuantity: item.packageQuantity,
            packagePeriodId: item.packagePeriodId,
            locationId: item.locationId,
            bundleNetwork: item.bundleNetwork,
            domain: item.domain,
            serviceNote: item.serviceNote,
            packageOptions: item.packageOptions,
            startDate: item.startDate,
            endDate: item.endDate,
          }
        }),
        siteId: contractDetail.generalServiceInfo.siteId,
        otherTechnicalDetail:
          contractDetail.generalServiceInfo.otherTechnicalDetail,
        notes: this.decorateContractNote(this.contractDetail.contractNotes),
        contactPoints: [...contactPointsList, ...saleContactList],
        startDate: contractDetail.generalServiceInfo.contractStartDate,
        endDate: null,
        escalationId: this.escalation?.escalationId,
      }
    },

    decorateContractNote(noteObject) {
      return noteObject.map((item) => item.note)
    },

    async onRequestAddAttachment(attachmentData) {
      await uploadContractAttachment(this.contractId, attachmentData).then(
        (response) => {
          if (response) {
            this.toastSuccess("Upload Attachment Successfully")
            this.getContractDetailByIdFromApi()
            this.getAttachmentTagOptionFromApi()
          } else {
            this.toastError("Upload Attachment Filled")
          }
        }
      )
      .catch(() => {
        this.toastError("Attachment uploaded failed. Please check the file size of your attachment and try again.")
      })
    },

    async onRequestEditAttachment(attachmentData) {
      await editContractAttachment(this.contractId, attachmentData).then(
        (response) => {
          if (response) {
            this.toastSuccess("Edit Attachment Successfully")
            this.getContractDetailByIdFromApi()
            this.getAttachmentTagOptionFromApi()
          } else {
            this.toastError("Upload Attachment Filled")
          }
        }
      )
      .catch(() => {
        this.toastError("Attachment updated failed. Please check the file size of your attachment and try again.")
      })
    },

    async onRequestDeleteAttachment(attachmentData) {
      await deleteContractAttachment(this.contractId, attachmentData).then(
        (response) => {
          if (response) {
            this.toastSuccess("Delete Attachment Successfully")
            this.getContractDetailByIdFromApi()
            this.getAttachmentTagOptionFromApi()
          } else {
            this.toastError("Upload Attachment Filled")
          }
        }
      )
    },
  },
}
</script>

<style lang="scss" scoped></style>
